import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { Container, Stack, Button, Table, Col, Row } from "react-bootstrap";
import Modal from "react-modal";
import { RecipeForm } from './RecipeForm';
import { roundToDollars } from '../utils/MoneyUtils';
import { CustomizedTypeahead } from './CustomizedTypeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import moment from "moment";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { userAuthContext } from './userAuthContext';
import { getRecipe, getRecipies, saveRecipe, recordHistory, getDocData, Recipies } from '../data/RecipeData';
import ToggleButton from 'react-toggle-button';
import { Timestamp } from "firebase/firestore";


export class RecipeList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      recipies: new Recipies(),
      docRef: "",
      previousRef: "",
      isDeleteConfirmOpen: false,
      description: "",
      deleteDocRef: "",
      mode: "Add",
      showForm: false,
      didSave: true,
      show_deleted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.COLLECTION = "recipes";

  }

  toggleShowForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      didSave: true,
    }, () => {
      this.readRecipeMaps(this.state.show_deleted);
    });

  }

  toggleMode = (mode) => {
    this.setState({
      docRef: "",
      mode: mode,
      showForm: true,
      didSave: false,
    });
  }


  handleUpdate = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'Edit',
      didSave: false,
    });
  }

  handleCopy = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'Copy',
      didSave: false,
    });
  }

  handleDelete = async (docRef) => {
    let newHistoryList = new Array();
    let now = Timestamp.now();
    let recipeDoc = await getRecipe(docRef);
    let recipe = recipeDoc.data();
    recipe.is_deleted = !recipe.is_deleted;
    newHistoryList = recipe.history;
    await recordHistory(newHistoryList, now, recipe, docRef);
    recipe.history = newHistoryList;
    
    let docData = getDocData(recipe);

    await saveRecipe(docRef, docData)
    this.readRecipeMaps(this.state.show_deleted);

  }

  handleView = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'View',
      didSave: true,
    });
  }

  async readRecipeMaps(show_deleted) {
    let tempRecipies = await getRecipies(show_deleted);
    this.setState({
      recipies: tempRecipies,
    });
  }

  componentDidMount() {
    this.readRecipeMaps();
    window.addEventListener('beforeunload', this.beforeunload.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.beforeunload.bind(this));
  }

  beforeunload(e) {
    if (!this.state.didSave) {
      e.preventDefault();
      e.returnValue = '';
    }
  }

  scrollToView(ref) {
    if (this.state.previousRef !== '' && this.state.previousRef.current) {
      let oldRef = this.state.previousRef;
      oldRef.current.style.background = 'white';
      this.setState({
        previousRef: "",
      })
    }
    setTimeout(() => {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      ref.current.style.background = 'gray';
      this.setState({
        previousRef: ref,
      })
    });
  }

  renderTableRow = (docRef, doc) => {
    let lastUpdatedString = "";
    if (doc.last_update) {
      lastUpdatedString = moment(doc.last_update.toDate()).format('MM/DD/YYYY HH:mm:ss');
    }
    let deleteText = "";
    let deleted = "";
    if (doc.is_deleted) {
      deleteText = "Undelete"
      deleted = "Y"
    } else {
      deleteText = "Delete"
      deleted = "N"
    }

    return (
      <tr key={docRef} ref={this.state.recipies.refMap.get(docRef)}>
        <td>{doc.name}</td>
        <td>{roundToDollars(doc.cost_per_item_high)}</td>
        <td>{roundToDollars(doc.cost_per_item_low)}</td>
        <td>{doc.low_profit_index}</td>
        <td>{doc.hours_taken}</td>
        <td>{doc.makes_qty}</td>
        <td>{roundToDollars(doc.total_ingredient_cost)}</td>
        <td>{roundToDollars(doc.total_batch_cost_high)}</td>
        <td>{roundToDollars(doc.total_batch_cost_low)}</td>
        <td>{lastUpdatedString}</td>
        {this.state.show_deleted && <td show={this.state.show_deleted}>{deleted}</td>}
        <td>
          <Stack direction="horizontal" gap={2}>
            <DropdownButton variant="dark" id="dropdown-basic-button" title="Actions">
              <Dropdown.Item variant="dark" onClick={() => { this.handleView(docRef) }}>View</Dropdown.Item>
              <Dropdown.Item variant="dark" onClick={() => { this.handleUpdate(docRef) }}>Edit</Dropdown.Item>
              <Dropdown.Item variant="dark" onClick={() => { this.handleCopy(docRef) }}>Copy</Dropdown.Item>
              <Dropdown.Item variant="dark" onClick={() => { this.handleDelete(docRef) }}>{deleteText}</Dropdown.Item>
            </DropdownButton>
          </Stack>
        </td>
      </tr>
    );

  }


  render() {

    let docMap = this.state.recipies.docMap;

    return (
      <>
        {
          /* 
          * Recipe List
          */
        }
        <Stack gap={3}>
          {!this.state.showForm &&
            <Container fluid>
              <Row className="justify-content-md-left">
                <Col>
                  <h2>Recipes:</h2>
                </Col>
                <Col>
                  <Button variant="dark" onClick={() => { this.toggleMode('Add') }}>Add New Recipe</Button>
                </Col>
                <Col>
                  <label htmlFor="show_deleted">Show Deleted?</label>
                  <ToggleButton
                    id="show_deleted"
                    inactiveLabel={'No'}
                    activeLabel={'Yes'}
                    value={this.state.show_deleted}
                    onToggle={(value) => {
                      this.setState({
                        show_deleted: !this.state.show_deleted,
                      }, () => {
                        this.readRecipeMaps(this.state.show_deleted);
                      })
                    }} />
                </Col>
                <Col md="auto">
                  Find:
                </Col>
                <Col md="auto">
                  <CustomizedTypeahead
                    onChange={(selected) => {
                      //console.log("selected" + selected);
                      if (selected.length > 0) {
                        let ref = this.state.recipies.refMap.get(selected[0].id);
                        this.scrollToView(ref);
                      }
                    }}
                    id='recipe_typeahead'
                    align='left'
                    labelKey={'value'}
                    options={this.state.recipies.options}
                  />
                </Col>
              </Row>
            </Container>
          }
          {this.state.showForm &&
            <userAuthContext.Consumer>
              {context => (
                <RecipeForm
                  context={context}
                  docRef={this.state.docRef}
                  mode={this.state.mode}
                  toggleForm={() => { this.toggleShowForm() }}
                />
              )}
            </userAuthContext.Consumer>

          }
          <Modal
            className='modalDialog'
            isOpen={this.state.isDeleteConfirmOpen}
            onRequestClose={this.toggleModal}
            contentLabel="My dialog"
          >
            <div>
              Delete {this.state.description}?
            </div>
            <Button variant="dark" size="sm" onClick={() => { this.toggleDeleteModal() }}>Cancel</Button>{' '}
            <Button variant="dark" size="sm" onClick={() => { this.handleDelete(this.state.deleteDocRef) }}>Confirm</Button>
          </Modal>
          {!this.state.showForm &&
            <div className='scrollingTable'>
              <Table bordered hover>
                <thead>
                  <tr className='header'>
                    <th className='table-header'>Name</th>
                    <th className='table-header'>Cost per Item High Profit</th>
                    <th className='table-header'>Cost per Item Low Profit</th>
                    <th className='table-header'>Low Profit Index</th>
                    <th className='table-header'>Hours Taken</th>
                    <th className='table-header'>Makes</th>
                    <th className='table-header'>Total Ingredient Cost</th>
                    <th className='table-header'>Batch Cost High Profit</th>
                    <th className='table-header'>Batch Cost Low Profit</th>
                    <th className='table-header'>Last Update</th>
                    {this.state.show_deleted && <th className='table-header'>Deleted?</th>}
                    <th className='table-header'></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...docMap].map(([key, value]) => {
                      return this.renderTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </div>
          }
        </Stack>
      </>
    );

  }
}